import { MapView } from "@msuite/ui/map";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { getWebfleetCoordinateValue } from "@msuite/utils/integrations";
import { guardString } from "@msuite/utils/strings";
import { useMemo } from "react";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";
import { VehicleMapPin } from "../vehicles/vehicle/panels/vehicle-general/vehicle-map-pin";

export function CommandMap() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	// The Webfleet objects are the fleet under another name, and the endpoint gates on
	// `read Vehicle`. Without the rule the query stays disabled rather than refetching a refusal
	// every three minutes, and the map renders without pins.
	const q = useQuery({
		queryKey: ["webfleet", "resources"],
		queryFn: async () => {
			const response = await client.integrations.webfleet.resources.$get({
				query: { includeIntegrated: "true" },
			});
			const data = await responseHandler(response);
			return data.resources;
		},
		refetchInterval: 1_000 * 60 * 3,
		enabled: citadel?.can("read", "Vehicle") === true,
	});

	const items = useMemo(() => {
		return guardArray(q.data)
			.map((resource) => {
				if (!resource.latitude || !resource.longitude) {
					return null;
				}
				return {
					licensePlate: resource.objectname,
					latitude: getWebfleetCoordinateValue(resource.latitude_mdeg),
					longitude: getWebfleetCoordinateValue(resource.longitude_mdeg),
					render: () => (
						<div className="v-stack flex-center">
							<VehicleMapPin className="w-24 h-24" />
							<div className="text-[8px] bg-black/80 **:text-white! px-1">
								<p>{resource.objectname}</p>
							</div>
						</div>
					),
				};
			})
			.filter((item) => item !== null);
	}, [q.data]);

	/** Render */
	return (
		<div className="aspect-5/4 w-full card p-0 overflow-hidden shrink-0">
			<MapView
				apiKey={guardString(process.env.PUBLIC_GOOGLE_MAPS_API_KEY)}
				mapId={process.env.PUBLIC_GOOGLE_MAPS_MAP_ID!}
				markers={items}
				defaultZoom={11}
			/>
		</div>
	);
}
